var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},_vm._l((4),function(item){return _c('div',{key:item},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":require("./jk.jpg")}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }